import {FormControl} from '@angular/forms';

export const createDuplicateValidator = (checkDuplicate: (value: string) => boolean) => {
  return (control: FormControl<string>) => {
    if (!control.value) return null;
    return checkDuplicate(control.value) ? {duplicateName: true} : null;
  };
};
